import api from "../../api";
import {typedQuery} from "../typing";

export const loginMethods = typedQuery(["loginMethods"], async () => {
  return await api.loginMethod.list();
});
